import CalendarRequest from '@tencent/calendar-framework-request';
const http = new CalendarRequest({
  timeout: 5000
});
const WechatGetJSSDKToken = (data, ctx) => http.post('/wemeet-tapi', '/v2/we-chat/get-jssdk-token', data, ctx, {});
export default WechatGetJSSDKToken;